export default {
  appTitle: 'Web de proveedores',
  title: 'Autorizaciones',
  filterLabel: 'Filtrar por',
  orderLabel: 'Ordenar por',
  authorizationTabLabel: 'Autorizaciones',
  loadingDataLabel: 'Obteniendo autorizaciones',
  emptyDataLabel: 'No se encontraron resultados',
  tryAgainLabel: 'Intente buscando otro término o ',
  paginationSizeLabel: 'Resultados/página',
  addAuthorization: 'Nueva autorización',
  addAuthorizationShortLabel: 'Nueva',
  resultLabel: '{result} resultado | {result} resultados',
  lastUpdateLabel: 'Última actualización: {datetime}',
  cleanFilters: 'limpiando los filtros',
  filtersAppliedLabel: ' aplicados',
  createAuthorization: {
    success: 'La autorización fue creada exitosamente.',
    error: 'Ocurrió un error en la creación de la autorización.'
  },
  filters: {
    status: 'Estado',
    from: 'Desde',
    to: 'Hasta',
    dateRange: 'Rango de fechas',
    searchCode: 'Buscar por ID'
  },
  order: {
    createdAt: 'Fecha de creación',
    beneficiaryName: 'Nombre de asegurado (a-z)',
    coverageType: 'Cobertura (a-z)',
    status: 'Estado'
  },
  authorizationGrid: {
    code: 'ID',
    createdAt: 'Fecha de creación',
    sponsor: 'Aseguradora',
    beneficiary: 'Asegurado/a',
    memberCode: 'Carnet',
    authorizationType: 'Tipo de autorización',
    status: 'Estado'
  },
  status: {
    error: 'Error',
    paid: 'Pagado',
    voided: 'Anulado',
    expired: 'Expirado',
    canceled: 'Cancelado',
    completed: 'Completado',
    inProgress: 'En progreso',
    failed: 'Fallido',
    ready: 'Listo',
    expirationInProgress: 'Expiración en proceso',
    updateInProgress: 'Actualización en proceso'
  },
  types: {
    pharmacy: 'Farmacia',
    process: 'Procedimiento',
    prescriptionDrugs: 'Medicamentos',
    diagnosticTest: 'Pruebas de diagnóstico',
    sports: 'Deportes',
    wellness: 'Gastos medicos',
    education: 'Educación',
    creditCardBalance: 'Saldo deudor',
    occupationalHazard: 'Riesgo laboral'
  },
  tabs: {
    requests: 'Solicitudes',
    newRequest: 'Nueva solicitud',
    profile: 'Perfil',
    prescription: 'Recetar',
    schedule: 'Agenda'
  }
}
